import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {LocalStorage} from 'ngx-webstorage';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-controls-messages',
    templateUrl: './controls-messages.component.html',
    styleUrls: ['./controls-messages.component.scss'],
    imports: [DatePipe, TranslateModule]
})
export class ControlsMessagesComponent implements OnInit {
    @Input() control: FormControl|AbstractControl;
    public _dateMin: Date = null;
    @LocalStorage() public dateShort; // FR de base

    @Input() set dateMin(value) {
        if (
            value != null &&
            value != '' &&
            value != false &&
            value != 'Invalid Date'
        ) {
            this._dateMin = new Date(value);
        }
    }

    public _dateMax: Date = null;
    @Input() set dateMax(value) {
        if (
            value != null &&
            value != '' &&
            value != false &&
            value != 'Invalid Date'
        ) {
            this._dateMax = new Date(value);
        }
    }

    @Input() dateType: string;
    @Input() rangeMin: string;
    @Input() rangeMax: string;

    public _min: number = null;
    @Input() set min(value) {
        if(value != null &&
            value != '' &&
            value != false) {
            this._min = parseInt(value,0);
        }
    }
    public _max: number = null;
    @Input() set max(value) {
        if(value != null &&
            value != '' &&
            value != false) {
            this._max = parseInt(value,0);
        }
    }

    constructor() {}

    ngOnInit() {}
}
